import { styles as commonStyles } from '../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
export const templateAwsSensor = document.createElement('template');

templateAwsSensor.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
    <gz-form-field  class="sensor-select-wrapper mb-2">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">
        <gz-form-field label="" id="aws_access_key_id" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="aws_secret_access_key" required stacked>
        <gz-input gz-form-input="" type="password" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="aws_queue_url" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
